<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">{{$t('HISTORICOOBSERVACOES.MOTIVOURGENCIA')}}</p>
        </header>
        <section class="modal-card-body">
            <div v-if="isLoading">
                <b-loading :is-full-page="false" :can-cancel="false" active></b-loading>
            </div>
            <table v-else class="table is-fullwidth">
                <tr v-for="(item, index) in lista" v-bind:key="index">
                    <td>
                        <h4>{{ item.descricao }}</h4>
                    </td>
                    <td>
                        <span><b>{{ item.usuarioNome }}</b> ({{ item.usuarioId }})</span>
                    </td>
                    <td>
                        <span>{{ item.dataHora | moment('DD/MM/YYYY HH:mm') }}</span>
                    </td>
                </tr>
            </table>
        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$emit('close')">{{$t('SISTEMA.CANCELAR')}}</button>
        </footer>
    </div>
</template>

<script>
    export default {
        props: {
            guiaId: Number,
        },
        data() {
            return {
                lista: [],
                isLoading: false,
            }
        },
        created(){
            this.loadHistoricoAlteracoes()
        },
        methods: {

            loadHistoricoAlteracoes() {
                this.$http.get('/api/atendimento/GuiaObservacoesUrgencia?id=' + this.guiaId)
                    .then(res => {
                        this.lista = res.data;                                                    
                    })
            },              
        }
    }
</script>